module.exports = __webpack_public_path__ + "static/media/turtles.7b042d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/games/turtles.jpg
// module id = 28
// module chunks = 0